module.exports = __webpack_public_path__ + "Shoppinglist_icon.png?499b0304fe023ec2b5d89d5c47ff417d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/Shoppinglist_icon.png
// module id = 223
// module chunks = 0